// 验证码服务 - 使用 Cloudflare Workers
export interface SendCodeOptions {
  email: string;
  code_type?: 'email_verification' | 'password_reset' | 'email_change';
  language?: string;
}

export interface VerifyCodeOptions {
  email: string;
  code: string;
  code_type?: 'email_verification' | 'password_reset' | 'email_change';
}

export interface ApiResponse {
  success: boolean;
  message: string;
}

export class VerificationCodeService {
  // Cloudflare Workers 的 URL
  private static readonly WORKER_URL = 'https://auth-resend.cubemeet.app';

  /**
   * 发送验证码
   */
  static async sendVerificationCode(options: SendCodeOptions): Promise<ApiResponse> {
    const { email, code_type = 'email_verification', language } = options;
    // Worker currently supports only 'zh-CN' and 'en'.
    const SUPPORTED_LANGS = ['zh-CN', 'en'];
    const langToSend = SUPPORTED_LANGS.includes(language || '') ? (language as string) : 'en';
    
    try {
      console.log('发送验证码请求:', { email, code_type, language: langToSend });
      
      const response = await fetch(`${this.WORKER_URL}/send-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          code_type,
          language: langToSend,
        }),
      });

      console.log('Workers 响应状态:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Workers 响应错误:', errorText);
        return { success: false, message: `请求失败: ${response.status}` };
      }

      const result = await response.json();
      console.log('Workers 响应结果:', result);
      return result;
    } catch (error) {
      console.error('发送验证码网络错误:', error);
      return { success: false, message: '网络错误，请检查连接' };
    }
  }

  /**
   * 验证验证码
   */
  static async verifyCode(options: VerifyCodeOptions): Promise<ApiResponse> {
    const { email, code, code_type = 'email_verification' } = options;

    try {
      console.log('验证验证码请求:', { email, code, code_type });
      
      const response = await fetch(`${this.WORKER_URL}/verify-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          code,
          code_type,
        }),
      });

      console.log('验证响应状态:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('验证响应错误:', errorText);
        return { success: false, message: `验证失败: ${response.status}` };
      }

      const result = await response.json();
      console.log('验证响应结果:', result);
      return result;
    } catch (error) {
      console.error('验证验证码网络错误:', error);
      return { success: false, message: '网络错误，请检查连接' };
    }
  }

  /**
   * 检查服务健康状态
   */
  static async healthCheck(): Promise<boolean> {
    try {
      const response = await fetch(`${this.WORKER_URL}/health`);
      const result = await response.json();
      return result.status === 'ok';
    } catch (error) {
      console.error('健康检查失败:', error);
      return false;
    }
  }
}

export default VerificationCodeService;
